import { render } from "./LeaveDurationInput.vue?vue&type=template&id=676a941c&scoped=true"
import script from "./LeaveDurationInput.vue?vue&type=script&lang=js"
export * from "./LeaveDurationInput.vue?vue&type=script&lang=js"

import "./LeaveDurationInput.vue?vue&type=style&index=0&id=676a941c&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\hr\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676a941c"]])

export default __exports__